import { createSlice } from '@reduxjs/toolkit'

const defaultOption = { id: '', displayText: '' }
const allocationInitialState = {
  selectedProgram: defaultOption,
  selectedAllocationType: defaultOption,
  selectedDestinationCropCycle: defaultOption,
  selectedPlantingCropCycle: defaultOption,
  selectedSourceCropCycleIsClosed: false,
  selectedTypeOfPotato: defaultOption,
  selectedGeneration: defaultOption,
  selectedVariety: defaultOption,
  selectedReceiver: defaultOption,
  selectedViewDemandIn: defaultOption,
  isDisposalDialogOpen: false,
  isReturningFromContract: false,
  selectedVarietyTabIndex: 0,
  masters: {},
  seedClassificationGradeData: [],
  programGeneralSettings: {},
  selectedPotatoCategory: {},
  // Dropdown options
  dropdownOptions: {
    allocationTypeOptions: [],
    typeOfPotatoOptions: [],
    generationOptions: [],
    viewDemandInOptions: [],
  },
  areaCode: '',
  quantityCode: '',
}

export const allocationSlice = createSlice({
  name: 'allocation',
  initialState: allocationInitialState,
  reducers: {
    setFilterData: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    setAllocationTypeOptionsInstore: (state, action) => ({
      ...state,
      allocationTypes: action.payload,
    }),
    setDisposalDialogOpen: (state, action) => ({
      ...state,
      isDisposalDialogOpen: action.payload,
    }),
    setMasterMessageData: (state, action) => ({
      ...state,
      masters: action.payload,
    }),
    setSeedClassificationGradeData: (state, action) => ({
      ...state,
      seedClassificationGradeData: action.payload,
    }),
    setProgramGenralSettings: (state, action) => ({
      ...state,
      programGeneralSettings: action.payload,
    }),
    setSelectedPotatoCategory: (state, action) => ({
      ...state,
      selectedPotatoCategory: action.payload,
    }),
    setDropdownOptions: (state, action) => ({
      ...state,
      dropdownOptions: {
        ...state.dropdownOptions,
        ...action.payload,
      },
    }),
    setAreaAndQuantityCodes: (state, action) => ({
      ...state,
      areaCode: action.payload.areaCode,
      quantityCode: action.payload.quantityCode,
    }),
    setIsReturningFromContract: (state, action) => ({
      ...state,
      isReturningFromContract: action.payload,
    }),
    setSelectedVarietyTabIndex: (state, action) => ({
      ...state,
      selectedVarietyTabIndex: action.payload,
    }),
  },
})

export const {
  setFilterData,
  setAllocationTypeOptionsInstore,
  setDisposalDialogOpen,
  setMasterMessageData,
  setSeedClassificationGradeData,
  setProgramGenralSettings,
  setSelectedPotatoCategory,
  setDropdownOptions,
  setAreaAndQuantityCodes,
  setIsReturningFromContract,
  setSelectedVarietyTabIndex,
} = allocationSlice.actions

export default allocationSlice.reducer
